<div class="infobox-container" [className]="type">
  <ng-content></ng-content>
</div>

